module.exports = __webpack_public_path__ + "img/calendar-27_fill.5a156b1e.svg";